import { selectChangeMessageForAccessRights } from '@UI/aside/asideAccessRights/asideAccessRightsSelectors';
import type { EditAsideAccessRights } from '@nodeTypeConfig/configTypes';

export const proAccessRightsComponent: EditAsideAccessRights = {
  component: 'accessRights',
  reactComponent: 'AsideAccessRights',
  property: 'descendantsAccessRights',
  label: 'Afscherming',
  labelSingular: 'Afscherming',
  isInheritedProperty: true,
  asideChangeMessageSelector: selectChangeMessageForAccessRights,
} as const;
